<script>
import RefreshSearchBtn from "@/views/pages/project/sale/RefreshSearchBtn.vue";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import _debounce from "lodash/debounce";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  name: "EstimateTab",
  components: { RefreshSearchBtn, CommonTableComponent },
  mixins: [pagination, tableSearch],
  props: {
    activeTabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      estimates: [],
      filters: {
        keywords: this.$route.query.keywords ? this.$route.query.keywords : "",
        column: this.$route.query.column || "estimate_cd",
        dir: this.$route.query.dir || "ASC"
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.$emit("get-data", true);
      const url = apiEndpoints.projects_sales_estimates.replace(
        ":id",
        this.$route.params.id
      );
      const sendApiProject = await this.$http.get(url, this.filters);
      const { status, data } = sendApiProject;

      if (status && data.result) {
        this.estimates = data.result;
      }
      this.$emit("get-data", false);
    },
    onRefreshSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: { ...this.customQuery, searchToken: this.getSearchToken() }
      });
    },
    handlerSearchValue() {
      this.updateUrlFilters();
    }
  },
  watch: {
    "filters.page": {
      immediate: false,
      handler() {
        this.updateUrlFilters();
      }
    }
  },
  computed: {
    customQuery() {
      return {
        activeTabIndex: this.activeTabIndex
      };
    },
    headers() {
      return [
        {
          text: "見積明細番号",
          value: "estimate_cd",
          sortable: true
        },
        {
          text: "廃棄物・サービス",
          value: "zz_waste_or_service_id",
          sortable: true
        },
        {
          text: "請求書表示用商品名",
          value: "invoice_product_name",
          sortable: true
        },
        {
          text: "適用開始日",
          value: "start_date_of_application",
          sortable: true
        },
        {
          text: "適用終了日",
          value: "end_date_of_application",
          sortable: true
        },
        {
          text: "単価",
          value: "unit_price",
          sortable: true
        },
        {
          text: "単位",
          value: "zz_unit_id",
          sortable: true
        },
        {
          text: "原単価",
          value: "unit_cost",
          sortable: true
        }
      ];
    },
    projectId() {
      return this.$route.params.id;
    }
  }
};
</script>
<template>
  <b-row align-h="center">
    <h5>見積一覧</h5>
    <div class="mt-1">
      <input
        placeholder="フィルター..."
        v-model="filters.keywords"
        v-on:keyup.enter="handlerSearchValue()"
        type="text"
        class="form-control me-2"
      />
    </div>
    <b-col class="mt-1">
      <CommonTableComponent
        :height-class="`table-wrapper-500`"
        :scrollAble="estimates.length >= this.$constant.scroll_able_records"
      >
        <thead class="table-light">
          <tr>
            <th
              v-for="(item, index) in headers"
              :key="index"
              :class="[{ 'col-sortable': item.sortable }]"
            >
              <span v-if="item.sortable" @click="clickSort(item.value)">
                {{ item.text }}
                <i :class="getSortClass(item.value)"></i>
              </span>
              <span v-else>
                {{ item.text }}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in estimates" :key="index">
            <td>{{ item.estimate_cd }}</td>
            <td>{{ item.waste_or_service && item.waste_or_service.waste_or_service }}</td>
            <td>{{ item.invoice_product_name }}</td>
            <td class="text-end">{{ item.start_date_of_application }}</td>
            <td class="text-end">
              <div v-if="item.end_date_of_application">{{ item.end_date_of_application}}</div>
              <div v-if="item.end_date_of_application_2">{{ item.end_date_of_application_2}}</div>
              <div v-if="item.end_date_of_application_3">{{ item.end_date_of_application_3}}</div>
            </td>
            <td class="text-end">
              <div v-if="item.unit_price">{{ item.unit_price | number}}</div>
              <div v-if="item.unit_price_2">{{ item.unit_price_2 | number}}</div>
              <div v-if="item.unit_price_3">{{ item.unit_price_3 | number}}</div>
            </td>
            <td class="text-end">{{ item.zz_unit && item.zz_unit.unit }}</td>
            <td class="text-end">
              <div v-if="item.unit_cost">{{ item.unit_cost | number}}</div>
              <div v-if="item.unit_cost_2">{{ item.unit_cost_2 | number}}</div>
              <div v-if="item.unit_cost_3">{{ item.unit_cost_3 | number}}</div>
            </td>
          </tr>
          <tr v-if="!estimates.length">
            <td :colspan="headers.length" class="text-center">
              データなし。
            </td>
          </tr>
        </tbody>
      </CommonTableComponent>
    </b-col>
  </b-row>
</template>
